import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
		Menu
	} from '@headlessui/vue'

	import {
		getCurrentInstance,
		provide
	} from 'vue'

	
	const __default__ = { name: 'VDropdown' }// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const menuId = 'menu-' + getCurrentInstance()?.uid
	provide('menuId', menuId)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "relative"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})